module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgement#ack",
      "id": "ack"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Introduction#int",
      "id": "int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Part01#pt1",
      "id": "pt1"
    }
  }, [_c('i', [_vm._v("Part I. Redrawing the Boundaries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#ch1",
      "id": "ch1"
    }
  }, [_vm._v("1  Accommodation and Exclusion: Writing Community in the 1559 "), _c('i', [_vm._v("Book of Common Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part02#pt2",
      "id": "pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part II. Early Responses—Mourning and Exclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02#ch2",
      "id": "ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2  Failing Consolation in Edmund Spenser’s Elegies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03#ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3  Robert Southwell’s Mission of Mourning")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Part03#pt3",
      "id": "pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Part III. Later Responses—Accommodating the Mystical Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter04#ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4  Reading Communion: Mystical Audience in John Donne’s Lyric Poetry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter05#ch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  In or Out? Lingering on the Threshold of George Herbert’s "), _c('i', [_vm._v("The Temple")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter06#ch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  Incarnating Mystical Community in Crashaw’s English Lyrics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#notes",
      "id": "notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bibliography#bib",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Index01#idx",
      "id": "idx",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b863104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Contents.vue
// module id = 75
// module chunks = 0